module.exports = __webpack_public_path__ + "img/projects.67189b14.svg";